import React from 'react'
import { Helmet } from 'react-helmet'

import CardList from 'components/common/CardList'
import Content from 'components/common/Content'
import { AgentsCard } from 'components/dashboard/cards/AgentsCard'
import { RecentExperimentsCard } from 'components/dashboard/cards/RecentExperimentsCard'
import { RecentScenariosCard } from 'components/dashboard/cards/RecentScenariosCard'
import { ServicesCard } from 'components/dashboard/cards/ServicesCard'
import TutorialBanner from 'components/dashboard/footer/TutorialBanner'
import { DashboardHeader } from 'components/dashboard/header/DashboardHeader'
import { Header, Heading } from 'components/navigation/Header'
import useAttackResource from 'hooks/use-attack-resource'
import useAuth from 'hooks/use-auth'
import useClientResource from 'hooks/use-client-resource'
import theme from 'theme'

import ScheduledExperimentsCard from './cards/ScheduledExperimentsCard'
import TotalAttacksRunCard from './cards/TotalAttacksRunCard'
import UniqueTargetsAttackedCard from './cards/UniqueTargetsAttackedCard'

export const CARD_WIDTH = 500

export const Dashboard: React.FC = () => {
  const { hasReliabilityManagement } = useAuth()

  const {
    activeScenarios,
    activeScenariosLoading,
    completed: completedAttacks,
    active: activeAttacks,
    partialCompletedAttacksLoaded,
    kubernetesAttacksLoading,
    applicationAttacksLoading
  } = useAttackResource({ fetchCompletedFully: false })

  // using partial fetch only as we don't need the full fetch anymore
  const attacksLoading =
    !partialCompletedAttacksLoaded ||
    kubernetesAttacksLoading ||
    applicationAttacksLoading

  const allAttacks = [].concat(activeAttacks, completedAttacks)
  const clientResource = useClientResource()

  return (
    <>
      <Helmet title="Dashboard" />
      <Header>
        <Heading>Dashboard</Heading>
      </Header>
      <Content data-test-dashboard id="Dashboard">
        <DashboardHeader />
        <CardList
          css={{
            marginTop: theme.space[4]
          }}
          minWidth={CARD_WIDTH}
        >
          {hasReliabilityManagement && <ServicesCard />}
          <AgentsCard
            allAttacks={allAttacks}
            attacksLoading={attacksLoading}
            clientResource={clientResource}
          />
          <TotalAttacksRunCard />
          <RecentScenariosCard
            scenarios={activeScenarios}
            scenariosLoading={activeScenariosLoading}
          />
          <RecentExperimentsCard
            allAttacks={allAttacks}
            attacksLoading={attacksLoading}
          />
          <ScheduledExperimentsCard />
          <UniqueTargetsAttackedCard />
        </CardList>
        <TutorialBanner />
      </Content>
    </>
  )
}
